/** Live validation (docs/spec/03 §5) under the settings: errors in red, warnings in yellow. */

import type { CaveIssue } from '../../caves/validate';
import type { KitApi } from './api';
import { INK } from './layout';
import { fit } from './widgets';

const LINES = 3;
const WIDTH = 58;

/** One issue as a line, upper case, with its mark. */
export function issueLine(i: CaveIssue): string {
  return `${i.severity === 'error' ? '■' : '▲'} ${i.message.toUpperCase()}`;
}

export function drawIssues(k: KitApi, x: number, y: number): void {
  const s = k.ui.screen;
  const info = k.st.info;
  if (info.issues.length === 0) {
    s.text('✓ READY: NO ERRORS, NO WARNINGS', x, y, INK.ok);
    s.text(`  TEST IT, SAVE IT, SHARE IT.`, x, y + 10, INK.dim);
    return;
  }
  // Errors first; they are what stops TEST.
  const sorted = [...info.issues].sort((a, b) => (a.severity === b.severity ? 0 : a.severity === 'error' ? -1 : 1));
  const shown = sorted.length > LINES ? sorted.slice(0, LINES - 1) : sorted;
  shown.forEach((issue, n) => {
    s.text(fit(issueLine(issue), WIDTH), x, y + n * 10, issue.severity === 'error' ? INK.error : INK.warning);
  });
  if (sorted.length > LINES) {
    const rest = sorted.slice(LINES - 1);
    const errors = rest.filter((i) => i.severity === 'error').length;
    s.text(`  AND ${rest.length} MORE (${errors} ERROR${errors === 1 ? '' : 'S'})`, x, y + (LINES - 1) * 10, INK.dim);
  }
  const tip = sorted.map((i) => i.message.toUpperCase()).join('; ');
  k.ui.add({ x, y: y - 1, w: 470, h: LINES * 10, id: 'issues', tip: fit(tip, 76) });
}
